import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getClientStats } from "../controller/get-client-usage"
import { Paper, TableCell, TableRow, Typography } from "@mui/material"
import { TabledRepeat } from "lib/@components/tabled-repeat/tabled-repeat"
import { format } from "date-fns"

function UserRow({ user }) {
    return (
        <TableRow>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.lastActivity ? format(new Date(user.lastActivity), "PPpp") : "Never"}</TableCell>
            <TableCell>{user.roles?.length ? user.roles.join(", ") : "None"}</TableCell>
            <TableCell>{user.license || "None"}</TableCell>
        </TableRow>
    )
}

export function ClientStats() {
    const { clientId: client } = useBoundContext()
    const stats = getClientStats.useResults(client)

    const tableHeaders = [
        { title: "Email", fieldKey: "email", sortable: false },
        { title: "Last Activity", fieldKey: "lastActivity", sortable: false },
        { title: "Roles", fieldKey: "roles", sortable: false },
        { title: "License", fieldKey: "license", sortable: false },
    ]

    return (
        <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
                Client Statistics
            </Typography>

            {stats && stats.regimeAccessCount && (
                <div style={{ marginBottom: 24 }}>
                    <Typography variant="h6">Regime Access</Typography>
                    <p>
                        Regimes: {stats.regimeAccessCount.inUse} used / {stats.regimeAccessCount.total} total
                    </p>
                </div>
            )}

            {stats && stats.userData && (
                <div style={{ marginBottom: 24 }}>
                    <Typography variant="h6" gutterBottom>
                        User Activity
                    </Typography>
                    <TabledRepeat
                        items={stats.userData}
                        itemPass="user"
                        itemComponent={<UserRow />}
                        tableHeaders={tableHeaders}
                        searchKeys={[
                            { key: "email", title: "Email" },
                            { key: "roles", title: "Roles" },
                            { key: "license", title: "License" },
                        ]}
                        paged={true}
                    />
                </div>
            )}
        </Paper>
    )
}
